module.exports = __webpack_public_path__ + "img/1537630585.9d8fed44.jpg";